<template>
  <div class="date-select-page">
    <byted-range-picker
      v-model="internalDate"
      format="YYYY-MM-DD"
      value-format="YYYY-MM-DD"
      :shortcuts="shortcutsR"
      editable
      :transfer="true"
      :placeholder="[startPlaceholder, endPlaceholder]"
      @change="handleChange"

    >
      <template slot="prefix">
        <div class="demo-prefix-label">{{ prefixLabel }}：</div>
      </template>
    </byted-range-picker>
  </div>
</template>

<style lang="less" scoped>
@import 'DateSelect';
</style>

<script>
import DateSelect from './DateSelect'
export default DateSelect
</script>
